import * as i1 from '@abp/ng.core';
import { mapEnumToOptions } from '@abp/ng.core';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';

var IdentityProPreventConcurrentLoginBehaviour;
(function (IdentityProPreventConcurrentLoginBehaviour) {
    IdentityProPreventConcurrentLoginBehaviour[IdentityProPreventConcurrentLoginBehaviour["Disabled"] = 0] = "Disabled";
    IdentityProPreventConcurrentLoginBehaviour[IdentityProPreventConcurrentLoginBehaviour["LogoutFromSameTypeDevices"] = 1] = "LogoutFromSameTypeDevices";
    IdentityProPreventConcurrentLoginBehaviour[IdentityProPreventConcurrentLoginBehaviour["LogoutFromAllDevices"] = 2] = "LogoutFromAllDevices";
})(IdentityProPreventConcurrentLoginBehaviour || (IdentityProPreventConcurrentLoginBehaviour = {}));
const identityProPreventConcurrentLoginBehaviourOptions = mapEnumToOptions(IdentityProPreventConcurrentLoginBehaviour);

var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    get IdentityProPreventConcurrentLoginBehaviour () { return IdentityProPreventConcurrentLoginBehaviour; },
    identityProPreventConcurrentLoginBehaviourOptions: identityProPreventConcurrentLoginBehaviourOptions
});

class IdentityClaimTypeService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.create = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/identity/claim-types',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.delete = (id, config) => this.restService.request({
            method: 'DELETE',
            url: `/api/identity/claim-types/${id}`,
        }, { apiName: this.apiName, ...config });
        this.get = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/claim-types/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/claim-types',
            params: {
                filter: input.filter,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.update = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/claim-types/${id}`,
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityClaimTypeService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityClaimTypeService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityClaimTypeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

var IdentityClaimValueType;
(function (IdentityClaimValueType) {
    IdentityClaimValueType[IdentityClaimValueType["String"] = 0] = "String";
    IdentityClaimValueType[IdentityClaimValueType["Int"] = 1] = "Int";
    IdentityClaimValueType[IdentityClaimValueType["Boolean"] = 2] = "Boolean";
    IdentityClaimValueType[IdentityClaimValueType["DateTime"] = 3] = "DateTime";
})(IdentityClaimValueType || (IdentityClaimValueType = {}));
const identityClaimValueTypeOptions = mapEnumToOptions(IdentityClaimValueType);

class IdentityExternalLoginService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.createOrUpdate = (config) => this.restService.request({
            method: 'POST',
            url: '/api/identity/external-login',
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityExternalLoginService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityExternalLoginService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityExternalLoginService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentityRoleService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.create = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/identity/roles',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.delete = (id, config) => this.restService.request({
            method: 'DELETE',
            url: `/api/identity/roles/${id}`,
        }, { apiName: this.apiName, ...config });
        this.get = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/roles/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getAllClaimTypes = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/roles/all-claim-types',
        }, { apiName: this.apiName, ...config });
        this.getAllList = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/roles/all',
        }, { apiName: this.apiName, ...config });
        this.getClaims = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/roles/${id}/claims`,
        }, { apiName: this.apiName, ...config });
        this.getList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/roles',
            params: {
                filter: input.filter,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.moveAllUsers = (id, roleId, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/roles/${id}/move-all-users`,
            params: { roleId },
        }, { apiName: this.apiName, ...config });
        this.update = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/roles/${id}`,
            body: input,
        }, { apiName: this.apiName, ...config });
        this.updateClaims = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/roles/${id}/claims`,
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityRoleService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityRoleService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityRoleService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentitySecurityLogService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.get = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/security-logs/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/security-logs',
            params: {
                startTime: input.startTime,
                endTime: input.endTime,
                applicationName: input.applicationName,
                identity: input.identity,
                action: input.action,
                userName: input.userName,
                clientId: input.clientId,
                correlationId: input.correlationId,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySecurityLogService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySecurityLogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySecurityLogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentitySessionService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.get = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/sessions/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/sessions',
            params: {
                userId: input.userId,
                device: input.device,
                clientId: input.clientId,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.revoke = (id, config) => this.restService.request({
            method: 'DELETE',
            url: `/api/identity/sessions/${id}`,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySessionService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySessionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySessionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentitySettingsService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.get = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/settings',
        }, { apiName: this.apiName, ...config });
        this.getLdap = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/settings/ldap',
        }, { apiName: this.apiName, ...config });
        this.getOAuth = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/settings/oauth',
        }, { apiName: this.apiName, ...config });
        this.getSession = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/settings/session',
        }, { apiName: this.apiName, ...config });
        this.update = (input, config) => this.restService.request({
            method: 'PUT',
            url: '/api/identity/settings',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.updateLdap = (input, config) => this.restService.request({
            method: 'PUT',
            url: '/api/identity/settings/ldap',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.updateOAuth = (input, config) => this.restService.request({
            method: 'PUT',
            url: '/api/identity/settings/oauth',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.updateSession = (input, config) => this.restService.request({
            method: 'PUT',
            url: '/api/identity/settings/session',
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySettingsService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySettingsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentitySettingsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentityUserLookupService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.findById = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/lookup/${id}`,
        }, { apiName: this.apiName, ...config });
        this.findByUserName = (userName, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/lookup/by-username/${userName}`,
        }, { apiName: this.apiName, ...config });
        this.getCount = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/lookup/count',
            params: { filter: input.filter },
        }, { apiName: this.apiName, ...config });
        this.search = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/lookup/search',
            params: {
                sorting: input.sorting,
                filter: input.filter,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserLookupService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserLookupService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserLookupService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

class IdentityUserService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.create = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/identity/users',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.delete = (id, config) => this.restService.request({
            method: 'DELETE',
            url: `/api/identity/users/${id}`,
        }, { apiName: this.apiName, ...config });
        this.findByEmail = (email, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/by-email/${email}`,
        }, { apiName: this.apiName, ...config });
        this.findById = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/by-id/${id}`,
        }, { apiName: this.apiName, ...config });
        this.findByUsername = (username, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/by-username/${username}`,
        }, { apiName: this.apiName, ...config });
        this.get = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getAllClaimTypes = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/all-claim-types',
        }, { apiName: this.apiName, ...config });
        this.getAssignableRoles = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/assignable-roles',
        }, { apiName: this.apiName, ...config });
        this.getAvailableOrganizationUnits = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/available-organization-units',
        }, { apiName: this.apiName, ...config });
        this.getClaims = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/${id}/claims`,
        }, { apiName: this.apiName, ...config });
        this.getDownloadToken = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/download-token',
        }, { apiName: this.apiName, ...config });
        this.getExternalLoginProviders = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/external-login-Providers',
        }, { apiName: this.apiName, ...config });
        this.getImportInvalidUsersFile = (input, config) => this.restService.request({
            method: 'GET',
            responseType: 'blob',
            url: '/api/identity/users/download-import-invalid-users-file',
            params: { token: input.token },
        }, { apiName: this.apiName, ...config });
        this.getImportUsersSampleFile = (input, config) => this.restService.request({
            method: 'GET',
            responseType: 'blob',
            url: '/api/identity/users/import-users-sample-file',
            params: { fileType: input.fileType, token: input.token },
        }, { apiName: this.apiName, ...config });
        this.getList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users',
            params: {
                filter: input.filter,
                roleId: input.roleId,
                organizationUnitId: input.organizationUnitId,
                userName: input.userName,
                phoneNumber: input.phoneNumber,
                emailAddress: input.emailAddress,
                name: input.name,
                surname: input.surname,
                isLockedOut: input.isLockedOut,
                notActive: input.notActive,
                emailConfirmed: input.emailConfirmed,
                isExternal: input.isExternal,
                maxCreationTime: input.maxCreationTime,
                minCreationTime: input.minCreationTime,
                maxModifitionTime: input.maxModifitionTime,
                minModifitionTime: input.minModifitionTime,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.getListAsCsvFile = (input, config) => this.restService.request({
            method: 'GET',
            responseType: 'blob',
            url: '/api/identity/users/export-as-csv',
            params: {
                token: input.token,
                filter: input.filter,
                roleId: input.roleId,
                organizationUnitId: input.organizationUnitId,
                userName: input.userName,
                phoneNumber: input.phoneNumber,
                emailAddress: input.emailAddress,
                name: input.name,
                surname: input.surname,
                isLockedOut: input.isLockedOut,
                notActive: input.notActive,
                emailConfirmed: input.emailConfirmed,
                isExternal: input.isExternal,
                maxCreationTime: input.maxCreationTime,
                minCreationTime: input.minCreationTime,
                maxModifitionTime: input.maxModifitionTime,
                minModifitionTime: input.minModifitionTime,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.getListAsExcelFile = (input, config) => this.restService.request({
            method: 'GET',
            responseType: 'blob',
            url: '/api/identity/users/export-as-excel',
            params: {
                token: input.token,
                filter: input.filter,
                roleId: input.roleId,
                organizationUnitId: input.organizationUnitId,
                userName: input.userName,
                phoneNumber: input.phoneNumber,
                emailAddress: input.emailAddress,
                name: input.name,
                surname: input.surname,
                isLockedOut: input.isLockedOut,
                notActive: input.notActive,
                emailConfirmed: input.emailConfirmed,
                isExternal: input.isExternal,
                maxCreationTime: input.maxCreationTime,
                minCreationTime: input.minCreationTime,
                maxModifitionTime: input.maxModifitionTime,
                minModifitionTime: input.minModifitionTime,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.getOrganizationUnitLookup = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/lookup/organization-units',
        }, { apiName: this.apiName, ...config });
        this.getOrganizationUnits = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/${id}/organization-units`,
        }, { apiName: this.apiName, ...config });
        this.getRoleLookup = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/users/lookup/roles',
        }, { apiName: this.apiName, ...config });
        this.getRoles = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/${id}/roles`,
        }, { apiName: this.apiName, ...config });
        this.getTwoFactorEnabled = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/users/${id}/two-factor-enabled`,
        }, { apiName: this.apiName, ...config });
        this.importExternalUser = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/identity/users/import-external-user',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.importUsersFromFile = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/identity/users/import-users-from-file',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.lock = (id, lockoutEnd, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/users/${id}/lock/${lockoutEnd}`,
        }, { apiName: this.apiName, ...config });
        this.setTwoFactorEnabled = (id, enabled, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/users/${id}/two-factor/${enabled}`,
        }, { apiName: this.apiName, ...config });
        this.unlock = (id, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/users/${id}/unlock`,
        }, { apiName: this.apiName, ...config });
        this.update = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/users/${id}`,
            body: input,
        }, { apiName: this.apiName, ...config });
        this.updateClaims = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/users/${id}/claims`,
            body: input,
        }, { apiName: this.apiName, ...config });
        this.updatePassword = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/users/${id}/change-password`,
            body: input,
        }, { apiName: this.apiName, ...config });
        this.updateRoles = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/users/${id}/roles`,
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: IdentityUserService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

var ImportUsersFromFileType;
(function (ImportUsersFromFileType) {
    ImportUsersFromFileType[ImportUsersFromFileType["Excel"] = 1] = "Excel";
    ImportUsersFromFileType[ImportUsersFromFileType["Csv"] = 2] = "Csv";
})(ImportUsersFromFileType || (ImportUsersFromFileType = {}));
const importUsersFromFileTypeOptions = mapEnumToOptions(ImportUsersFromFileType);

class OrganizationUnitService {
    constructor(restService) {
        this.restService = restService;
        this.apiName = 'AbpIdentity';
        this.addMembers = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/organization-units/${id}/members`,
            body: input,
        }, { apiName: this.apiName, ...config });
        this.addRoles = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/organization-units/${id}/roles`,
            body: input,
        }, { apiName: this.apiName, ...config });
        this.create = (input, config) => this.restService.request({
            method: 'POST',
            url: '/api/identity/organization-units',
            body: input,
        }, { apiName: this.apiName, ...config });
        this.delete = (id, config) => this.restService.request({
            method: 'DELETE',
            url: '/api/identity/organization-units',
            params: { id },
        }, { apiName: this.apiName, ...config });
        this.get = (id, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/organization-units/${id}`,
        }, { apiName: this.apiName, ...config });
        this.getAvailableRoles = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/organization-units/available-roles',
            params: {
                filter: input.filter,
                id: input.id,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.getAvailableUsers = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/organization-units/available-users',
            params: {
                filter: input.filter,
                id: input.id,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.getList = (input, config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/organization-units',
            params: {
                filter: input.filter,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.getListAll = (config) => this.restService.request({
            method: 'GET',
            url: '/api/identity/organization-units/all',
        }, { apiName: this.apiName, ...config });
        this.getMembers = (id, input, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/organization-units/${id}/members`,
            params: {
                filter: input.filter,
                roleId: input.roleId,
                organizationUnitId: input.organizationUnitId,
                userName: input.userName,
                phoneNumber: input.phoneNumber,
                emailAddress: input.emailAddress,
                name: input.name,
                surname: input.surname,
                isLockedOut: input.isLockedOut,
                notActive: input.notActive,
                emailConfirmed: input.emailConfirmed,
                isExternal: input.isExternal,
                maxCreationTime: input.maxCreationTime,
                minCreationTime: input.minCreationTime,
                maxModifitionTime: input.maxModifitionTime,
                minModifitionTime: input.minModifitionTime,
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
                extraProperties: input.extraProperties,
            },
        }, { apiName: this.apiName, ...config });
        this.getRoles = (id, input, config) => this.restService.request({
            method: 'GET',
            url: `/api/identity/organization-units/${id}/roles`,
            params: {
                sorting: input.sorting,
                skipCount: input.skipCount,
                maxResultCount: input.maxResultCount,
            },
        }, { apiName: this.apiName, ...config });
        this.move = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/organization-units/${id}/move`,
            body: input,
        }, { apiName: this.apiName, ...config });
        this.moveAllUsers = (id, organizationId, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/organization-units/${id}/move-all-users`,
            params: { organizationId },
        }, { apiName: this.apiName, ...config });
        this.removeMember = (id, memberId, config) => this.restService.request({
            method: 'DELETE',
            url: `/api/identity/organization-units/${id}/members/${memberId}`,
        }, { apiName: this.apiName, ...config });
        this.removeRole = (id, roleId, config) => this.restService.request({
            method: 'DELETE',
            url: `/api/identity/organization-units/${id}/roles/${roleId}`,
        }, { apiName: this.apiName, ...config });
        this.update = (id, input, config) => this.restService.request({
            method: 'PUT',
            url: `/api/identity/organization-units/${id}`,
            body: input,
        }, { apiName: this.apiName, ...config });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: OrganizationUnitService, deps: [{ token: i1.RestService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: OrganizationUnitService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.5", ngImport: i0, type: OrganizationUnitService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.RestService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { IdentityClaimTypeService, IdentityClaimValueType, IdentityExternalLoginService, IdentityRoleService, IdentitySecurityLogService, IdentitySessionService, IdentitySettingsService, IdentityUserLookupService, IdentityUserService, ImportUsersFromFileType, OrganizationUnitService, index as Settings, identityClaimValueTypeOptions, importUsersFromFileTypeOptions };
